import { render, staticRenderFns } from "./home.vue?vue&type=template&id=996fd878&"
import script from "./home.ts?vue&type=script&lang=ts&"
export * from "./home.ts?vue&type=script&lang=ts&"
import style0 from "./home.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports